<template>
  <div class="search-box">
    <div v-if="searchOpen" class="search-form">
      <input
        class="form-box"
        enterkeyhint="search"
        type="search"
        :placeholder="placeholder"
        v-model="searchQuery"
        @change="emitSearch"
      />
      <button @click="handleSearchOpen()" class="search-cancel-button">
        <!-- X画像のSVG -->
        <svg
          :width="cancelImgSize"
          :height="cancelImgSize"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.48 1.152L5.966 4.68L9.466 8.208L8.514 9.16L5 5.646L1.486 9.16L0.534 8.208L4.034 4.694L0.52 1.152L1.472 0.199999L5 3.728L8.528 0.199999L9.48 1.152Z"
            fill="#797676"
          />
        </svg>
      </button>
    </div>

    <button v-else class="search-button" @click="handleSearchOpen()">
      <!-- 虫眼鏡画像のSVG -->
      <svg
        :width="searchImgSize"
        :height="searchImgSize"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.53565 8.53565L8.26296 8.77007C7.43754 9.47964 6.36745 9.90595 5.20297 9.90595C2.60547 9.90595 0.5 7.80047 0.5 5.20297C0.5 2.60547 2.60547 0.5 5.20297 0.5C7.80047 0.5 9.90595 2.60547 9.90595 5.20297C9.90595 6.36745 9.47964 7.43754 8.77007 8.26296L8.53565 8.53565ZM9.30503 9.30503H9.37336H9.79832L13.2932 12.807L12.807 13.2932L9.30503 9.79832V9.37336V9.30503ZM1.10091 5.20297C1.10091 7.47225 2.93369 9.30503 5.20297 9.30503C7.47225 9.30503 9.30503 7.47225 9.30503 5.20297C9.30503 2.93369 7.47225 1.10091 5.20297 1.10091C2.93369 1.10091 1.10091 2.93369 1.10091 5.20297Z"
          fill="#797676"
          stroke="#797676"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    searchImgSize: {
      type: Number,
      default: 14
    },
    cancelImgSize: {
      type: Number,
      default: 10
    },
    placeholder: {
      type: String,
      default: "Search"
    }
  },
  data() {
    return {
      searchOpen: false,
      searchQuery: ""
    };
  },
  methods: {
    // 検索ボックスを開く関数
    handleSearchOpen() {
      this.searchOpen = !this.searchOpen;
    },
    // 親コンポーネントに検索queryを伝播させる関数
    emitSearch() {
      this.searchOpen = !this.searchOpen;
      this.$emit("search", this.searchQuery);
    }
  }
};
</script>

<style lang="css" scoped>
.search-box {
  display: flex;
  justify-content: end;
  align-items: center;
}
.search-button {
  background-color: white;
  border: solid 1px #777;
  border-radius: 100vh;
  width: 5vh;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.search-form {
  background-color: white;
  border: solid 1px #777;
  border-radius: 100vh;
  width: 30vh;
  height: 5vh;
  display: flex;
  justify-content: end;
  align-items: center;
}

.search-cancel-button {
  border: none;
  background: none;
  padding: none;
  margin-right: 1vh;
}

.form {
  width: 100vh;
  margin-left: 1vh;
  border: none;
}
.form-box {
  border: none;
  width: 100%;
  height: 100%;
  background-color: unset;
  margin-left: 10px;
  font-size: 16px;
}

.form-box::-webkit-search-cancel-button {
  -webkit-appearance: none;
  appearance: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseSearch.vue